import { render, staticRenderFns } from "./AddNewCategory.vue?vue&type=template&id=1b5621cf&"
import script from "./AddNewCategory.vue?vue&type=script&lang=js&"
export * from "./AddNewCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports